import {
  ELEMENT_TYPE_TEXT,
  ELEMENT_TYPE_UPLOAD,
  ELEMENT_TYPE_DESIGN
} from '@/plugins/composition-renderer/constants';
import { useControlLayerStore } from '@/store-pinia/control-layer';
import { useColorStore } from '@/store-pinia/colors';
import Redirect from '@/mixins/redirect';

const { redirect } = Redirect.methods;

export const productItem = {
  label: 'customization.product',
  routeName: 'product',
  iconName: 'product-icon-white'
};

export const productChangeItem = {
  label: 'product.change',
  routeName: 'product-change',
  iconName: 'choice-icon'
};

export const productColorItem = {
  label: 'product.color',
  routeName: 'product-color',
  iconName: 'color-icon'
};

export const printStyleItem = {
  label: 'customization.printStyle',
  routeName: 'printstyle',
  iconName: 'printingmode-icon'
};

export const productInfoItem = {
  label: 'customization.productInformation',
  routeName: 'productinfo',
  iconName: 'info-icon'
};

export const addUploadItem = {
  label: 'customization.upload',
  routeName: 'add-upload',
  iconName: 'upload-icon',
  element: ELEMENT_TYPE_UPLOAD
};

export const addDesignItem = {
  label: 'customization.motif',
  routeName: 'add-design',
  iconName: 'motif-icon',
  element: ELEMENT_TYPE_DESIGN
};

export const basketItem = {
  label: 'summary.addToBasket',
  routeName: 'basket',
  iconName: 'cart-icon',
  additionalClass: 'bg-sh-primary-lighten-5 md:pb-8'
};

export const addTextItem = {
  label: 'customization.text',
  iconName: 'text-icon-white',
  element: ELEMENT_TYPE_TEXT,
  onClick: async context => {
    const colorStore = useColorStore();
    await colorStore.loadFontColors();

    const controlLayer = useControlLayerStore();
    controlLayer.addTextElement(context.$t('customization.addTextPlaceholder'));

    if (context.trackEvent) {
      context.trackEvent({
        action: 'Text_Add'
      });
    }
    context.$root.$emit('reset-navigation');
    redirect('edit-text', 'instant');
  }
};

export const createItem = {
  label: 'customization.create',
  routeName: 'design',
  iconName: 'personalise-icon',
  infoTooltip: 'info.deactivatedFeatures'
};

export const shareDesignItem = {
  label: 'share.sharedesign',
  routeName: 'share-design',
  iconName: 'share-icon',
  onClick: context => {
    context.$refs.shareDesign.share();
  }
};
